import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useGetSingleFaq, useUpdatefaq } from '../api/faqapi';
import { CircularProgress } from '@mui/material';
import { PageLoader } from '../../../lib/loader';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const schema = yup.object().shape({
    question: yup.string()
        .required('Question is required'),
    answer: yup
        .string()
        .min(6, 'Answer should be atleast 6 characters.')
        .required('Answer is Required'),
})

function EditFaq({ editData, toggle }) {

    const navigate = useNavigate()

    const { data: SingleFaq, isLoading } = useGetSingleFaq(editData)

    const { control, handleSubmit, formState: { errors, isValid, isDirty }, reset, setValue } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            question: '',
            answer: '',
        }
    });

    useEffect(() => {
        fetchSingleFaq();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SingleFaq]);

    const fetchSingleFaq = async () => {
        if (SingleFaq) {
            setValue('question', SingleFaq?.data?.faqs?.question);
            setValue('answer', SingleFaq?.data?.faqs?.answer);
        }
    };

    const updateFaq = useUpdatefaq();
    const onSubmit = async (data) => {
        data['id'] = editData

        const res = await updateFaq.mutateAsync({ ...data })
        if (res?.status) {
            reset()
            toggle();
            navigate('/faq')
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {isLoading ?
                <PageLoader /> :
                <>
                    <div className='mb-3'>
                        <h6 className="pb-2">Question</h6>
                        <Controller
                            control={control}
                            name="question"
                            render={({ field }) => (
                                <input
                                    {...field}
                                    placeholder="Enter Question"
                                    className='form-control'
                                />
                            )}
                        />
                        {errors.question?.message && <p className='m-0 errMsg'>{errors.question?.message}</p>}
                    </div>
                    <div className='mb-3'>
                        <h6 className="pb-2">Answer</h6>
                        <Controller
                            control={control}
                            name="answer"
                            render={({ field }) => (
                                <input
                                    {...field}
                                    placeholder="Enter Answer"
                                    className='form-control'
                                />
                            )}
                        />
                        {errors.answer?.message && <p className='m-0 errMsg'>{errors.answer?.message}</p>}
                    </div>
                    <div className='d-flex justify-content-center rounded-pill'>
                        <button className='btn btn-primary d-flex align-items-center' disabled={EditFaq.isLoading || !isValid || !isDirty}>
                            {EditFaq.isLoading ?
                                <CircularProgress size={20} style={{ color: "#fff" }} className='mx-4' />
                                :
                                "Submit"}
                        </button>
                    </div>
                </>}
        </form>
    )
}

EditFaq.propTypes = {
    toggle: PropTypes.func.isRequired,
    editData: PropTypes.string.isRequired
};

export default EditFaq